module.exports = __webpack_public_path__ + "img/avi.b6a34356.svg";